module.exports = {
	carGalleryData: () => {
		return [
			{
				'ESCAPE TITANIUM 4X4 FHEV': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/1.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/2.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/3.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/4.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/5.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/6.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/7.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/8.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/9.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/10.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/11.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/12.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/13.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/14.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/15.webp'),
							LargeImage: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/02_GaleriaPublicitaria/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'ESCAPE ECOBOOST': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/1.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/2.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/3.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/4.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/5.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/6.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/7.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/07.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/07.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/8.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/9.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/10.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/11.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/12.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/13.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/14.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/15.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/16.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/16.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/17.webp'),
							LargeImage: require('./../assets/Galerias/01_EscapeEcoboost/02_GaleriaPublicitaria/17.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'ESCAPE SE 4X2 FHEV': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/1.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/2.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/3.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/4.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/5.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/6.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/7.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/8.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/9.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/10.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/11.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/12.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/13.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/14.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/15.webp'),
							LargeImage: require('./../assets/Galerias/02_EscapeSE4X2HEV/02_GaleriaPublicitaria/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'ESCAPE SEL 4X2 FHEV': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/1.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/2.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/3.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/4.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/5.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/6.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/7.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/8.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/9.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/10.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/11.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/12.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/13.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/14.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/15.webp'),
							LargeImage: require('./../assets/Galerias/03_EscapeSEL4X2HEV/02_GaleriaPublicitaria/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'EDGE SEL': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/3.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/6.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/7.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/8.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/12.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/13.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/14.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/15.webp'),
							LargeImage: require('./../assets/Galerias/07_EdgeSEL/02_Galeria/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'EDGE ST': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/3.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/6.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/7.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/8.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/9.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/10.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/12.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/13.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/14.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/08_EdgeST/Galeria/15.webp'),
							LargeImage: require('./../assets/Galerias/08_EdgeST/Galeria/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'EXPEDITION LIMITED': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/3.webp'),
							LargeImage: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/12_ExpeditionLimited/Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'EXPLORER LIMITED': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/3.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/6.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/7.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/8.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/9.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/10.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/12.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/13.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/14.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/15.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/16.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/16.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/17.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/17.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/18.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/18.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/19.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/19.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/10_ExplorerLimited/Galeria/20.webp'),
							LargeImage: require('./../assets/Galerias/10_ExplorerLimited/Galeria/20.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'EXPLORER ST': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/6.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/7.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/8.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/9.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/10.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/12.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/13.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/14.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/15.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/16.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/16.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/11_ExplorerST/Galeria/17.webp'),
							LargeImage: require('./../assets/Galerias/11_ExplorerST/Galeria/17.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'EXPLORER XLT': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/6.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/14.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/09_ExplorerXLT/Galerias/16.webp'),
							LargeImage: require('./../assets/Galerias/09_ExplorerXLT/Galerias/16.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'F-150 LARIAT SPORT': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/3.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/6.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/7.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/8.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/9.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/10.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/12.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/13.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/14.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/15.webp'),
							LargeImage: require('./../assets/Galerias/21_F150Latiat-Sport/Galeria/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'F-150 XLT FHEV': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/3.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/6.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/7.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/8.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/9.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/10.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/12.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/13.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/14.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150XLT/Galeria/15.webp'),
							LargeImage: require('./../assets/Galerias/F150XLT/Galeria/15.webp'),
							src: '',
							isVideo: false,
						}
					],
				},

				'F-150 PLATINUM FHEV': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/1.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/2.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/3.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/4.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/5.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/6.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/7.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/8.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/9.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/10.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/12.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/13.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/14.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/15.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/16.webp'),
							LargeImage: require('./../assets/Galerias/F150PlatinumFHEV/Galeria/16.webp'),
							src: '',
							isVideo: false,
						}
					],
				},

				'F-150 RAPTOR': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/6.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/14.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/23_F150Raptor/Galerias/16.webp'),
							LargeImage: require('./../assets/Galerias/23_F150Raptor/Galerias/16.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'MUSTANG MACH 1': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/Thumbnails/Mustang Mach 1.jpg'),
							LargeImage: '',
							src: 'https://www.youtube.com/embed/YuNnReAWeCM',
							isVideo: true,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/6.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/14.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/13_MustangMach1/Galerias/16.webp'),
							LargeImage: require('./../assets/Galerias/13_MustangMach1/Galerias/16.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'MUSTANG GT PREMIUM': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/6.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/14.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/16.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/16.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/14_MustangGTPremium/Galerias/17.webp'),
							LargeImage: require('./../assets/Galerias/14_MustangGTPremium/Galerias/17.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'RANGER RAPTOR': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/6.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/14.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/17.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/17.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/20_RangerRaptor/Galerias/16.webp'),
							LargeImage: require('./../assets/Galerias/20_RangerRaptor/Galerias/16.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'RANGER XL': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/01.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/01.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/04.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/04.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/05.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/05.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/06.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/06.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/07.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/07.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/08.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/08.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/09.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/09.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/10.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/16_RangerXL/Galeria/11.webp'),
							LargeImage: require('./../assets/Galerias/16_RangerXL/Galeria/11.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'RANGER XLS DIESEL': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/01.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/01.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/02.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/02.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/03.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/03.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/04.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/04.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/05.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/05.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/06.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/06.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/07.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/07.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/08.webp'),
							LargeImage: require('./../assets/Galerias/17_RangerXLSDiesel/Galeria/08.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'BRONCO SPORT WILDTRAK': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/Thumbnails/Bronco Sport.jpg'),
							LargeImage: '',
							src: 'https://www.youtube.com/embed/ZsAcIaM6ycw',
							isVideo: true,
						},
						{
							Thumbnail: require('./../assets/Galerias/Thumbnails/Bronco Sport 4x4.jpg'),
							LargeImage: '',
							src: 'https://www.youtube.com/embed/YI8ydQJb-2E',
							isVideo: true,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/05_BroncoWT/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/05_BroncoWT/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'BRONCO SPORT BIG BEND': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/06_BroncoBB/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/06_BroncoBB/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'BRONCO SPORT OUTER BANKS': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/6.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/6.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/Bronco_OB/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/Bronco_OB/Galerias/12.webp'),
							src: '',
							isVideo: false,
						}
					],
				},

				'RANGER LIMITED BLACK EDITION': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/16.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/16.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'RANGER XL CHASIS': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/25_RangerXLChasis/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/25_RangerXLChasis/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/25_RangerXLChasis/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/25_RangerXLChasis/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/25_RangerXLChasis/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/25_RangerXLChasis/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/25_RangerXLChasis/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/25_RangerXLChasis/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/25_RangerXLChasis/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/25_RangerXLChasis/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/25_RangerXLChasis/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/25_RangerXLChasis/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/25_RangerXLChasis/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/25_RangerXLChasis/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'RANGER LIMITED': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/11.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/11.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/12.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/12.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/13.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/13.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/14.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/14.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/15.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/15.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/16.webp'),
							LargeImage: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Galerias/16.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'RANGER FX4': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/27_RangerFX4/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/27_RangerFX4/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
					],
				},

				'RANGER XLT': {
					Galeria: [
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/1.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/1.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/2.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/2.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/3.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/3.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/4.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/4.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/5.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/5.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/7.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/7.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/8.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/8.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/9.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/9.webp'),
							src: '',
							isVideo: false,
						},
						{
							Thumbnail: require('./../assets/Galerias/28_RangerXLT/Galerias/10.webp'),
							LargeImage: require('./../assets/Galerias/28_RangerXLT/Galerias/10.webp'),
							src: '',
							isVideo: false,
						},
					],
				},
				
			},
		];
	},
};
